import { AdminActions } from "../actions";
import * as Actions from "../actions";
import { AdminState } from "../state";

import { fetchAppList } from "./FetchAppList";
import { fetchAppStats } from "./FetchAppStats";
import { transferApp } from "./TransferApp";
import { updateApp } from "./UpdateApp";

const initialState: AdminState = {
    apps: [],
    error: {}
};

export function adminReducer(state: AdminState = { ...initialState }, action: AdminActions): AdminState {
    const newState = mergeError(state, action);

    switch (action.type) {
        case Actions.ADMIN_FETCH_APP_LIST_END:
            return fetchAppList(newState, action);
        case Actions.ADMIN_FETCH_APP_STATS_END:
            return fetchAppStats(newState, action);
        case Actions.ADMIN_FETCH_STENTOR_EVENTS_END:
            return { ...newState, stentorEvents: action.payload.returnValue };
        case Actions.ADMIN_UPDATE_APP_END:
            return updateApp(state, action);
        case Actions.TRANSFER_APP_END:
            return transferApp(state, action);
        default:
            return newState;
    }
}

function mergeError(state: AdminState, action: Actions.AdminEndAction<any>) {
    const payload = { ...action.payload };
    const payloadError = payload.error;
    const error = { ...state.error, [action.type]: payloadError };

    return { ...state, error };
}
